export default, { VIEW_PROFILE, VIEW_PROFILE_EDIT } from './profile';



// WEBPACK FOOTER //
// ./app/components/profile/index.js